import React from "react";
import { useRoutes } from "react-router-dom";
import Main from "../pages/Main.jsx";
import CardGame from "../pages/CardGame.jsx";
import Matching from "../pages/Matching.jsx";
import Reports from "../pages/Reports.jsx";
import WordMaker from "../pages/WordMaker.jsx";
import GameResult from "../componenets/game/GameResult.jsx";
import Layout from "../componenets/Layout.jsx";

const AllRoutes = () => {
  return useRoutes([
    {
      element: <Layout />,
      children: [
        { path: "/", element: <Main /> },
        { path: "/card-game/:id", element: <CardGame /> },
        { path: "/wordmaker", element: <WordMaker /> },
        { path: "/matching", element: <Matching /> },
        { path: "/ai-reports", element: <Reports /> },
        { path: "/game-result", element: <GameResult /> },
      ]
    },
    { path: "*", element: <div>404 - 페이지를 찾을 수 없습니다.</div> }
  ]);
};

export { AllRoutes };
